/**
 * converts bytes into a human friendly value
 * https://stackoverflow.com/a/18650828/706442
 */
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * async/promise function for retrieving image dimensions for a file
 * https://stackoverflow.com/a/58897088
 */
export function imageSize(file) {
  const img = new Image();
  img.src = window.URL.createObjectURL(file);
  return new Promise((resolve, reject) => {
    img.onload = () => {
      // Natural size is the actual image size regardless of rendering.
      // The 'normal' `width`/`height` are for the **rendered** size.
      const width = img.naturalWidth;
      const height = img.naturalHeight;
      window.URL.revokeObjectURL(img.src);
      resolve({
        width,
        height
      });
    };
    img.onerror = error => {
      window.URL.revokeObjectURL(img.src);
      reject(error);
    };
  });
}

/**
 * function for validating file format
 */
export function isValidFormat(acceptedFormats, fileName) {
  // The accept attribute doesn't validate the types of the selected files,
  // it only provides hints for browsers to guide users towards selecting the correct file types.
  // Users can toggle the option in the file chooser and override this and select any file they wish, and then choose incorrect file types.
  // Because of this we're adding this validation before uploading.
  const path = fileName.split('.');
  if (path.length === 1) {
    throw new Error('missing_extension');
  }
  const extension = `${path[path.length - 1]}`;
  const regex = new RegExp(acceptedFormats.join('|'), 'i');
  return regex.test(extension);
}

/**
 * download html content to your local download directory in your computer
 */
export function downloadContent(fileName, htmlContent) {
  const aElement = document.createElement('a');
  aElement.setAttribute('download', fileName);
  const href = URL.createObjectURL(new Blob([htmlContent], {
    type: 'text/html'
  }));
  aElement.href = href;
  aElement.setAttribute('target', '_blank');
  aElement.click();
  URL.revokeObjectURL(href);
}